import { render, staticRenderFns } from "./opcoesEntregas.vue?vue&type=template&id=374ec477&scoped=true&"
import script from "./opcoesEntregas.vue?vue&type=script&lang=js&"
export * from "./opcoesEntregas.vue?vue&type=script&lang=js&"
import style0 from "./opcoesEntregas.vue?vue&type=style&index=0&id=374ec477&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374ec477",
  null
  
)

export default component.exports